<template>
  <div>
    <b-card>
      <TitleTable titleTable="Inventory categories" iconTable="fas fa-tags" />
      <b-row class="m-1 mb-2">
        <b-col class="d-flex justify-content-end">
          <GoBack class="mr-2" />
          <b-button variant="primary" @click="openAdd">Add</b-button>
        </b-col>
      </b-row>
      <b-table :items="items" :fields="fields" bordered responsive show-empty>
        <template #cell(active)="data">
          <b-badge :variant="data.item.active ? 'success' : 'secondary'">
            {{ data.item.active ? 'Active' : 'Inactive' }}
          </b-badge>
        </template>
        <template #cell(actions)="data">
          <b-button size="sm" variant="outline-primary" class="mr-1" @click="openEdit(data.item)"><i class="fas fa-pen"></i></b-button>
          <b-button size="sm" variant="outline-danger" @click="remove(data.item)"><i class="fas fa-trash-alt"></i></b-button>
        </template>
      </b-table>
    </b-card>
    <WlFormSidebar :visible.sync="sidebarVisible" sidebar-id="inv-cat-sidebar" :title="editId ? 'Edit' : 'New category'" :loading="saving" @submit="save">
      <b-form-group label="Name"><b-form-input v-model="form.name" /></b-form-group>
      <b-form-group label="Description"><b-form-textarea v-model="form.description" rows="2" /></b-form-group>
      <b-form-group label="Active"><b-form-checkbox v-model="form.active" switch /></b-form-group>
    </WlFormSidebar>
    <ToastNotification ref="toast" />
  </div>
</template>

<script>
import { BCard, BRow, BCol, BTable, BButton, BBadge, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox } from 'bootstrap-vue'
import TitleTable from '@/components/TitleTable.vue'
import GoBack from '@/components/ButtonBack.vue'
import ToastNotification from '@/components/ToastNotification'
import WlFormSidebar from '../components/WlFormSidebar.vue'
import invCategoriesApi from '@/core/services/api/weightloss-inventory/categories'
import Swal from 'sweetalert2'

export default {
  name: 'TableInvCategories',
  components: { BCard, BRow, BCol, BTable, BButton, BBadge, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, TitleTable, GoBack, ToastNotification, WlFormSidebar },
  data() {
    return {
      items: [],
      fields: [{ key: 'id' }, { key: 'name', label: 'Name' }, { key: 'description', label: 'Description' }, { key: 'active', label: 'Status' }, { key: 'actions', label: '' }],
      sidebarVisible: false, saving: false, editId: null,
      form: { name: '', description: '', active: true },
    }
  },
  mounted() { this.load() },
  methods: {
    async load() { this.items = await invCategoriesApi.list() },
    openAdd() { this.editId = null; this.form = { name: '', description: '', active: true }; this.sidebarVisible = true },
    openEdit(item) { this.editId = item.id; this.form = { name: item.name, description: item.description || '', active: !!item.active }; this.sidebarVisible = true },
    async save() {
      this.saving = true
      try {
        if (this.editId) await invCategoriesApi.update(this.editId, this.form)
        else await invCategoriesApi.create(this.form)
        this.$refs.toast.success('Guardado')
        this.sidebarVisible = false
        this.load()
      } catch (e) { this.$refs.toast.danger(e.message) } finally { this.saving = false }
    },
    remove(item) {
      Swal.fire({ title: 'Delete?', showCancelButton: true }).then(async r => {
        if (r.value) { await invCategoriesApi.remove(item.id); this.load() }
      })
    },
  },
}
</script>
